enum BookingStatus {
  PENDING = "PENDING",
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
  COMPLETED = "COMPLETED",
  ACTIVE = "ACTIVE",
  LAPSED = "LAPSED"
}

export default BookingStatus;
